import React from 'react';
import { Link, Navigate } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";
class Crearusuario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nombres:"",
            apellidos:"",
            usuario: "",
            contra: "",
            nochapa:"",
            rol: "",
            estado: "",
            redireccionar: false
        }
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

   enviarDatos = (e) => {
    e.preventDefault();

    const { nombres, apellidos, usuario, contra, nochapa, rol, estado } = this.state;

    const datosEnviar = {
        nombres,
        apellidos,
        usuario,
        contra,
        nochapa,
        rol,
        estado
    };

    fetch(api + "usuarios", {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify(datosEnviar)
    })
    .then(respuesta => respuesta.json())
    .then((datosRespuesta) => {

      

        if (datosRespuesta.success === 1) {
            this.setState({
                mensaje: "Usuario creado con éxito"
            });

            setTimeout(() => {
                this.setState({
                    redireccionar: true
                });
            }, 2000);
        } else {
            this.setState({
                mensaje: datosRespuesta.mensaje || "No se pudo crear el usuario"
            });
        }
    })
    .catch(error => {
       
        this.setState({
            mensaje: "Error al conectar con el servidor"
        });
    });
}

    render() {
        const { nombres, apellidos, usuario, contra, nochapa, rol, estado, mensaje, redireccionar } = this.state;

       
        if (redireccionar) {
            return <Navigate to="/usuarios" />;
        }

        return (
            <div className="card">
                <div className="card-header">
                   USUARIOS
                </div>

                <div className="card-body">

                    
                    {mensaje && (
                        <div className="alert alert-success">
                            {mensaje}
                        </div>
                    )}

                    <form onSubmit={this.enviarDatos}>

                        <div className="form-group">
                            <label>Nombres</label>
                            <input
                                type="text"
                                name="nombres"
                                onChange={this.cambioValor}
                                value={nombres}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe el Nombre del usuario
                            </small>
                        </div>

                        <div className="form-group">
                            <label>apellidos</label>
                            <input
                                type="text"
                                name="apellidos"
                                onChange={this.cambioValor}
                                value={apellidos}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe los apellidos del usuario                            </small>
                        </div>


                        <div className="form-group">
                            <label>Usuario</label>
                            <input
                                type="text"
                                name="usuario"
                                onChange={this.cambioValor}
                                value={usuario}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe el usuario del empleado
                            </small>
                        </div>

                        <div className="form-group">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                name="contra"
                                onChange={this.cambioValor}
                                value={contra}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe la contraseña del empleado
                            </small>
                        </div>

                        <div className="form-group">
                            <label>No. Chapa</label>
                            <input
                                type="text"
                                name="nochapa"
                                onChange={this.cambioValor}
                                value={nochapa}
                                className="form-control"
                            />
                            <small className="text-muted">
                                Escribe el No. de Chapa del usuario
                            </small>
                        </div>

                        <div className="form-group">
                                 <label htmlFor="rol">Rol del empleado</label>

                                 <select
                                    name="rol"
                                    onChange={this.cambioValor}
                                    value={String(rol)}
                                    id="rol"
                                    className="form-control"
                                    aria-describedby="helpRol"
                                 >
                                    <option value="">Seleccione un rol</option>
                                    <option value="1">Administrador</option>
                                    <option value="2">Secretaria</option>
                                    <option value="3">Agente</option>
                                </select>

                                    <small id="helpRol" className="text-muted">
                                    Selecciona el Rol del empleado
                                    </small>
                            </div>

                            <div className="form-group">
                                 <label htmlFor="rol">Estado del empleado</label>

                                 <select
                                    name="estado"
                                    onChange={this.cambioValor}
                                    value={String(estado)}
                                    id="rol"
                                    className="form-control"
                                    aria-describedby="helpRol"
                                 >
                                    <option value="">Seleccione un estado</option>
                                    <option value="1">Activo</option>
                                    <option value="2">Inactivo</option>
                                    <option value="3">Suspendido</option>
                                </select>

                                    <small id="helpRol" className="text-muted">
                                    Selecciona el Estado del empleado
                                    </small>
                            </div>

                        <div className="btn-group">
                            <button type="submit" className="btn btn-success">
                                Agregar Nuevo Usuario
                            </button>

                            <Link to="/usuarios" className="btn btn-primary">
                                Cancelar
                            </Link>
                        </div>
                    </form>

                </div>

                <div className="card-footer text-muted">
                    PMT EN TODO
                </div>
            </div>
        );
    }
}

export default Crearusuario;